import { useState } from 'react';

import { Alert, Button, Dialog, DialogTitle, DialogActions, DialogContent } from '@mui/material';

import { useTranslate } from 'src/locales';

import OrgCandidateProfileResumeUploader from 'src/components/profile-importer/candidate-resume-importer';

type Props = {
  candidateId: string;
  open: boolean;
  onClose: VoidFunction;
  onSuccess?: VoidFunction;
};

export default function OrgCandidateProfileImporterDialog({
  candidateId,
  open,
  onClose,
  onSuccess = () => {},
}: Props) {
  const { t } = useTranslate();

  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const handleClose = () => {
    setErrorMessage(null);
    onClose();
  };

  const handleSuccess = () => {
    setErrorMessage(null);
    onSuccess();
  }

  return (
    <Dialog open={open} onClose={handleClose} fullWidth>
      <DialogTitle>{t('applications.candidate_resume_importer.modal.title')}</DialogTitle>
      <DialogContent>
        {errorMessage && (
          <Alert sx={{ mb: 2 }} severity="error">
            {errorMessage}
          </Alert>
        )}
        <OrgCandidateProfileResumeUploader
          candidateId={candidateId}
          showWarning
          onSuccess={handleSuccess}
          onError={setErrorMessage}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>{t('common.cancel')}</Button>
      </DialogActions>
    </Dialog>
  );
}
